exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "demo-component{color:red}", "", {"version":3,"sources":["/./source/components/demo-component/demo-component.css"],"names":[],"mappings":"AAAA,eACI,SAAW,CACd","file":"demo-component.css","sourcesContent":["demo-component {\n    color: red;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/postcss-loader!./source/components/demo-component/demo-component.css
// module id = 395
// module chunks = 0